import React from 'react';
import { AppBar, Toolbar, Button, Box, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NavBar = ({ isAuthenticated, username, handleLogout, handleOpenLogin, handleOpenRegister }) => {
    const navigate = useNavigate();

    const handleNavClick = (path) => {
        navigate(path);
    };

    return (
        <AppBar position="static">
            <Toolbar>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item xs={4}>
                        <Box sx={{ flexGrow: 1 }} />
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button color="inherit" onClick={() => handleNavClick('/')}>Home</Button>
                        <Button color="inherit" onClick={() => handleNavClick('/ads')}>Ads</Button>
                        <Button color="inherit" onClick={() => handleNavClick('/stats')}>Stats</Button>
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {isAuthenticated ? (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="h6" component="div" sx={{ mr: 2 }}>
                                    {username}
                                </Typography>
                                <Button color="inherit" onClick={handleLogout}>
                                    Logout
                                </Button>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button color="inherit" onClick={handleOpenLogin}>
                                    Login
                                </Button>
                                <Button color="inherit" onClick={handleOpenRegister}>
                                    Register
                                </Button>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};

export default NavBar;